var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"title":_vm.$t('lbl_EMPBE_Report')}}),_c('visitorPermission',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',{staticClass:"font-roboto report-container"},[_c('div',{staticClass:"card"},[_c('Report',{attrs:{"IsStrus":1}})],1)])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }